export const DEFAULT_LAYOUT_OVERRIDE={
  logoScale:1,
  logoOffsetX:0,
  logoOffsetY:0,
  imageScale:1,
  imageOffsetX:0,
  imageOffsetY:0,
  headlineFontScale:1,
  subheadFontScale:1
};

export function getLayoutOverride(layoutOverrides={},layoutId) {
  const stored=layoutOverrides?.[layoutId];

  if (!stored || typeof stored!=='object') {
    return {...DEFAULT_LAYOUT_OVERRIDE};
  }

  return {
    ...DEFAULT_LAYOUT_OVERRIDE,
    ...stored
  };
}

export function hasCustomLayoutOverride(layoutOverrides={},layoutId) {
  const current=getLayoutOverride(layoutOverrides,layoutId);

  return Object.keys(DEFAULT_LAYOUT_OVERRIDE).some(
    (key)=> current[key]!==DEFAULT_LAYOUT_OVERRIDE[key]
  );
}

export function buildOverrideTransform(scale,offsetX,offsetY) {
  if (scale===1 && offsetX===0 && offsetY===0) {
    return undefined;
  }

  return `scale(${scale}) translate(${offsetX}cqw,${offsetY}cqw)`;
}
